import { motion } from 'motion/react';
import { ArrowUpIcon } from 'lucide-react';
import type { BadgeProps } from '../types';

export function Badge({ text, isSelected, onClick }: BadgeProps): JSX.Element {
  return (
    <motion.button
      onClick={onClick}
      className={`flex gap-1 w-full items-center p-3 pe-4 rounded-full cursor-pointer transition-all border border-gray-200 text-sm font-medium ${
        isSelected
          ? 'bg-[#F8F9FC] border-[#9AA2D0] text-[#3E4784]'
          : 'bg-white border-[#d5d7da] shadow-[0px_1px_2px_0px_rgba(10,13,18,0.05)] text-[#414651]'
      }`}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.98 }}
    >
      <ArrowUpIcon size={16} stroke="currentColor" />
      <span>{text}</span>
    </motion.button>
  );
}
